window.addEventListener('load', function () {
    if (document.querySelectorAll('.storeLocator').length) {
        const results = document.querySelector('#wpsl-stores');
        const target = document.querySelector('body');
        var timer;

        results.addEventListener('click', function (event) {
            if (event.target.closest('li.store')) {
                clearTimeout(timer);

                if (!results.classList.contains('disable-hover')) {
                    results.classList.add('disable-hover');
                }

                timer = setTimeout(function () {
                    results.classList.remove('disable-hover');
                }, 1000);

                target.scrollIntoView({ behavior: 'smooth' });
            }
        });
    }
});
